<template>

  <div>
    <b-breadcrumb>
      <b-breadcrumb-item>Administratie</b-breadcrumb-item>
      <b-breadcrumb-item to="/main/admin/invoices" active>Facturen</b-breadcrumb-item>
    </b-breadcrumb>

    <h2>Facturen</h2>

    <table-wrap :fields="$options.fields" small striped :query="$options.query" :per-page="perPage" hover
      :state.sync="state" :reset-state="$store.state.resetPrintersView">

      <template #cell(created)="{item}">
        {{item.created|format_moment('YYYY-MM-DD')}}
      </template>
      <template #cell(contract)="{item:{contract}}">
        <b-link :to="`/main/admin/contracts/view/${contract.id}`">{{contract.name}}</b-link>
      </template>

      <template v-slot:cell(actions)="{item}">
        <!--<template v-if="row.item.contract">
          <b-btn variant="warning" size="sm">Verwijderen uit contract</b-btn>
        </template>
        <template v-else>
          <b-btn variant="primary" size="sm">Toewijzen aan contract</b-btn>
        </template>-->
<!--        <b-btn variant="danger" size="sm" @click="deletePrinter(row)"><span class="mdi mdi-trash-can-outline"/> Verwijderen</b-btn>-->
        <b-btn variant="primary" size="sm" :href="item.sourceUrl" class="ml-1" target="_blank"><span class="mdi mdi-open-in-new"/> Bekijken</b-btn>
      </template>

    </table-wrap>



  </div>


</template>

<script>

import { mapState} from 'vuex';
import TableWrap from '../../components/TableWrap';
import vuex_computed from '@/lib/vuex_computed';
import {M_UPDATE_INVOICES_VIEW} from '@/lib/constants';
import actionField from '@/lib/actionField';

export default
{
    components: { TableWrap },
    computed:
    {
        ...mapState(['perPage']),
        state: vuex_computed('invoicesView', M_UPDATE_INVOICES_VIEW)
    },
    methods:
    {
    },
    fields:
    [
        {
            key: 'created',
            label: 'Opgemaakt',
            sort: 'CREATED',
            sortable: true,
        },
        {
            key: 'contract.customer.name',
            label: 'Klant',
            search: 'STRING',
            searchPath: 'contract.customer.name'
        },
        {
            key: 'contract',
            search: 'STRING',
            searchPath: 'contract.name'
        },
        {
            key: 'quarter',
            label: 'Kwartaal'
        },
        {
            key: 'year',
            label: 'Jaar'
        },
        {
            key: 'title',
            label: 'Titel'
        },
        actionField
    ],
    query: require('../../graphql/live/list_invoices.gql')
}
</script>

<style scoped>

</style>